/**
 * アスペクト比計算ユーティリティ
 * Graph Builderのプレビュー領域でアスペクト比を維持したサイズ計算に使用
 */

import { AspectRatioPreset } from '../../types/graph-builder.types';

/**
 * アスペクト比プリセットから数値の比率を取得
 * @param preset アスペクト比プリセット
 * @returns 数値の比率（width/height）、customの場合はnull（固定高さを使用）
 */
export function getAspectRatioValue(preset: AspectRatioPreset): number | null {
  switch (preset) {
    case '16:9': return 16 / 9;
    case '4:3': return 4 / 3;
    case '1:1': return 1;
    case '3:4': return 3 / 4;
    case '9:16': return 9 / 16;
    case 'custom':
    default:
      return null; // customの場合はnull（固定高さを使用）
  }
}

/**
 * アスペクト比プリセットをCSS aspect-ratio値に変換
 * @param preset アスペクト比プリセット
 * @returns CSS aspect-ratio値（例: '16 / 9'）、customの場合はundefined
 */
export function getAspectRatioCssValue(preset: AspectRatioPreset): string | undefined {
  switch (preset) {
    case '16:9': return '16 / 9';
    case '4:3': return '4 / 3';
    case '1:1': return '1 / 1';
    case '3:4': return '3 / 4';
    case '9:16': return '9 / 16';
    case 'custom':
    default:
      return undefined;
  }
}

/**
 * コンテナサイズとアスペクト比から、アスペクト比を維持した最大サイズを計算
 * @param containerWidth コンテナの幅
 * @param containerHeight コンテナの高さ
 * @param aspectRatio アスペクト比（width/height）
 * @param padding パディング（デフォルト: 0）
 * @returns 計算されたサイズ { width, height }
 */
export function calculateSizeWithAspectRatio(
  containerWidth: number,
  containerHeight: number,
  aspectRatio: number,
  padding: number = 0
): { width: number; height: number } {
  const availableWidth = containerWidth - padding * 2;
  const availableHeight = containerHeight - padding * 2;

  let width: number;
  let height: number;

  if (availableWidth / availableHeight > aspectRatio) {
    // コンテナが横長 → 高さ基準
    height = availableHeight;
    width = height * aspectRatio;
  } else {
    // コンテナが縦長 → 幅基準
    width = availableWidth;
    height = width / aspectRatio;
  }

  return { width, height };
}
